export const yearArrayGenerate = () => {
  const startYear = 2023
  const currentDate = new Date().getFullYear()
  return Array(currentDate - startYear + 1).fill('').map((_, i) => ({
    id: i + 1,
    year: startYear + i
  })).sort((a, b) => b.year - a.year)
}